/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const regionActions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class regionStore extends Reflux.Store {
	constructor() {
		super();
		this.state = {
			storeData:{
				regionName:'',
				regionCode:'',
				active:null,
				s: 10,
				p: 1
			}
		}
		this.listenables = regionActions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/region/store.js